import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../portal/loading.service';

export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);
export const SKIP_LOADER_HEADER = 'X-Skip-Loader';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (shouldSkipLoader(req)) {
    return next(req);
  }

  const loading = inject(LoadingService);
  loading.track();

  return next(req).pipe(finalize(() => loading.untrack()));
};

function shouldSkipLoader(req: { url: string; context: { get(token: HttpContextToken<boolean>): boolean }; headers: { has(name: string): boolean } }): boolean {
  if (req.context.get(SKIP_LOADER)) return true;
  if (req.headers.has(SKIP_LOADER_HEADER)) return true;

  const url = req.url.toLowerCase();
  if (url.includes('/health')) return true;
  if (url.includes('/data/') && url.endsWith('.json')) return true;

  return false;
}
